// the upgrade buttons' glint: a light stripe sweeps across once per hover. The transition only
// runs towards the hover state, leaving snaps the stripe back unseen
export const glintOnHover = {
  position: 'relative',
  overflow: 'hidden',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-60%',
    width: '40%',
    height: '100%',
    background: 'linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.35), transparent)',
    transform: 'skewX(-20deg)',
    pointerEvents: 'none',
  },
  '&:hover::after': {
    left: '130%',
    transition: 'left 0.7s ease-out',
  },
  '@media (prefers-reduced-motion: reduce)': {
    '&::after': { display: 'none' },
  },
};
